import { defineMessages } from 'react-intl';

export default defineMessages({
  advertising: {
    id: 'Advertising',
    defaultMessage: 'Advertising',
  }
});
